import { loadStripe, Stripe } from '@stripe/stripe-js';

let _stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!_stripePromise) {
    const env = (window as any).__ENV__;
    const key = env.STRIPE_PUBLISHABLE_KEY;
    if (!key) {
      throw new Error('STRIPE_PUBLISHABLE_KEY is not defined');
    }
    _stripePromise = loadStripe(key);
  }
  return _stripePromise;
}
